import {
	createTheme,
	alpha,
	ThemeOptions,
	Theme
} from "@material-ui/core/styles";
import { Shadows } from "@material-ui/core/styles/shadows";

import "../dployTheme";
import "../dployTheme";

export const name = "Classic";
export const id = "classic";

export const muiTheme = (theme: Theme): Theme => {
	theme = createTheme({
		palette: {
			primary: theme.palette.primary,
			secondary: theme.palette.secondary
		},
		typography: {
			fontFamily: "inherit",
			fontSize: 12,
			// lineHeight: 1.15,
			h1: {
				fontSize: "2.5rem"
			},
			h2: {
				fontSize: "2rem"
			},
			h3: {
				fontSize: "1.75rem"
			},
			h4: {
				fontSize: "1.5rem"
			},
			h5: {
				fontSize: "1.25rem"
			},
			h6: {
				fontSize: "1rem"
			}
		},
		breakpoints: {
			values: {
				xs: 400,
				sm: 450,
				md: 768,
				lg: 960,
				xl: 1280
			}
		},
		spacing: 6,
		shape: {
			borderRadius: 0
		},
		shadows: Array(25).map(_ => "none") as Shadows,
		overrides: theme.overrides,
		props: theme.props
	});

	const classic: ThemeOptions = {
		overrides: {
			MuiFormControl: {
				marginNormal: {
					marginTop: 20
				},
				root: {
					marginTop: 20,
					"& button": {
						height: 20
					}
				}
			},
			MuiInputBase: {
				root: {
					marginTop: "0 !important",
					padding: "0 !important",
					border: "1px solid !important"
				},
				input: {
					padding: "1px 4px !important"
				}
			},
			MuiInputLabel: {
				formControl: {
					transform: "translate(0px, -20px) scale(1) !important"
				},
				outlined: {
					transform: "translate(0px, -20px) scale(1) !important"
				},
				filled: {
					transform: "translate(0px, -20px) scale(1) !important"
				},
				root: {
					transform: "translate(0px, -17px) scale(1)",
					whiteSpace: "nowrap",
					textOverflow: "ellipsis",
					overflow: "hidden",
					maxWidth: "100%",
					lineHeight: 1.5
				}
			},
			DployTextFieldLabel: {
				shrink: {
					transform: "translate(0px, -20px) scale(1)"
				}
			},
			MuiOutlinedInput: {
				notchedOutline: {
					border: "none"
				}
			},
			MuiFilledInput: {
				root: {
					backgroundColor: undefined,
					"&:hover": {
						backgroundColor: undefined
					},
					"&$focused": {
						backgroundColor: undefined
					}
				},
				underline: {
					"&:before": {
						content: undefined
					},
					"&:after": {
						content: undefined
					}
				}
			},
			MuiInput: {
				underline: {
					"&:before": {
						content: undefined
					},
					"&:after": {
						content: undefined
					}
				}
			},
			MuiSelect: {
				select: {
					paddingRight: "20px !important"
				}
			},
			MuiFormHelperText: {
				root: {
					margin: "4px 8px 0 !important",
					fontSize: 10
				}
			},
			MuiMenu: {
				list: {
					paddingTop: 0,
					paddingBottom: 0
				}
			},
			MuiMenuItem: {
				root: {
					lineHeight: "inherit",
					minHeight: "none",
					padding: "3px 1em 3px .4em !important"
				}
			},
			MuiListItem: {
				root: {
					height: "auto"
				}
			},
			// MuiListItemText: {
			// 	root: {
			// 		marginTop: "0 !important",
			// 		marginBottom: "0 !important"
			// 	}
			// },
			MuiCircularProgress: {
				root: {
					"button &": {
						height: "16px !important",
						width: "16px !important"
					}
				}
			},
			MuiIconButton: {
				root: {
					borderRadius: 0,
					padding: "0 12px"
				}
			},
			MuiButton: {
				root: {
					minWidth: "none"
				}
			},
			MuiButtonBase: {
				root: {
					textTransform: "none",
					fontWeight: 400,
					height: 22,
					lineHeight: "inherit !important",
					padding: "0 8px",
					fontSize: "inherit !important"
				}
			},
			MuiToggleButton: {
				sizeSmall: {
					height: 22
				},
				root: {
					height: 22,
					backgroundColor: theme.palette.grey[100],
					border: `1px solid ${theme.palette.grey[300]}`,
					textTransform: "none",
					color: theme.palette.grey[900],

					"&:not(:first-child)": {
						borderLeft: `1px solid ${theme.palette.grey[300]}`
					},

					"&:hover": {
						backgroundColor: theme.palette.grey[200]
					},

					"&$disabled": {
						color: alpha(theme.palette.grey[900], 0.6),
						backgroundColor: alpha(theme.palette.grey[100], 0.8)
					},

					"&$selected": {
						backgroundColor: theme.palette.grey[800],
						color: theme.palette.common.white,
						fontWeight: "bold",

						"&$disabled": {
							color: theme.palette.common.white,
							backgroundColor: alpha(theme.palette.grey[800], 0.8)
						},

						"&:hover": {
							backgroundColor: theme.palette.grey[700]
						}
					}
				},
				sizeLarge: {
					height: 20
				}
			},
			MuiTablePagination: {
				selectIcon: {
					top: -3
				}
			},
			MuiPaper: {
				root: {
					border: "1px solid #f2f2f2"
				}
			},
			MuiAccordion: {
				root: {
					"&:before": {
						content: ""
					},
					"&:not(:first-child)": {
						borderTop: 0
					},
					"&$expanded": {
						marginTop: 0,
						marginBottom: 0
					}
				}
			},
			MuiTabs: {
				root: {
					minHeight: "auto"
				}
			},
			MuiTab: {
				textColorInherit: {
					color: theme.palette.primary.main
				},
				root: {
					minHeight: "auto",
					color: theme.palette.primary.main,
					boxSizing: "border-box",
					border: "1px solid rgba(224, 224, 224, 1)",
					borderBottom: "none",
					textTransform: "none",
					marginLeft: 1,
					marginRight: 1,
					fontSize: 11,
					fontWeight: 700,

					[theme.breakpoints.up("xs")]: {
						minWidth: "auto"
					},

					"&:not($selected):not(:hover)": {
						backgroundColor: theme.palette.primary.main,
						color: theme.palette.primary.contrastText,
						opacity: 1
					}
				}
			},
			MuiTable: {
				root: {
					background: `${theme.palette.background.paper}`
				}
			},
			MuiTableCell: {
				root: {
					padding: 5,
					fontSize: 10,
					border: "1px solid rgba(224, 224, 224, 1)"
				},
				paddingNone: {
					"& > * > button": {
						padding: "0 !important"
					}
				},
				head: {
					background: `${theme.palette.primary.main} !important`,
					color: theme.palette.primary.contrastText,
					"& > *": {
						padding: "0 !important"
					}
				},
				body: {
					"& > *": {
						padding: "0 !important",
						margin: "0 !important",
						"& > *": {
							border: "none !important"
						}
					}
				}
			},
			MuiTableRow: {
				root: {
					"&:nth-child(odd)": {
						backgroundColor: theme.palette.grey[50]
					}
				}
			},
			MuiTableSortLabel: {
				root: {
					"&:hover": {
						color: theme.palette.primary.contrastText
					},
					"&$active": {
						color: theme.palette.primary.contrastText,
						"&& $icon": {
							opacity: 1,
							color: theme.palette.primary.contrastText
						}
					}
				}
			},
			MuiChip: {
				root: {
					height: "auto",
					borderRadius: 0,
					marginTop: "0 !important",
					marginBottom: "0 !important"
				},
				deleteIcon: {
					fontSize: "0.8rem"
				}
			},
			MuiAutocomplete: {
				endAdornment: {
					top: "calc(50% - 10px)"
				}
			},
			DployExpandableTable: {
				headerCell: {
					backgroundColor: theme.palette.primary.main,
					color: theme.palette.primary.contrastText
				}
			},
			DployFormLiteral: {
				root: {
					fontSize: 16,
					lineHeight: 1
				}
			}
		},
		props: {
			MuiOutlinedInput: {
				notched: false
			},
			MuiInputLabel: {
				shrink: false
			},
			MuiList: {
				dense: true
			},
			MuiTable: {
				// dense: true
			}
		}
	};

	return createTheme(theme, classic);
};
